const rootUrl = window.location.protocol + '//' + window.location.host;
const redirectUri = rootUrl + '/oauth/callback';
const newPasswordUrl = rootUrl + '/set-new-password';

// Check if we're in E2E testing mode
const isE2E =
  import.meta.env.VITE_NODE_ENV === 'test' ||
  import.meta.env.VITE_E2E === 'true';
const isDev =
  import.meta.env.VITE_NODE_ENV === 'development' ||
  import.meta.env.VITE_NODE_ENV === 'dev' ||
  window.location.hostname === 'localhost';

// Debug logging
console.log('Config detection:', {
  hostname: window.location.hostname,
  port: window.location.port,
  search: window.location.search,
  isE2E,
  isDev,
  clientId: isE2E
    ? 'pos-dashboard-test'
    : import.meta.env.VITE_API_CLIENT ?? 'pos-dashboard',
});

export const configs = {
  apiRoot: '/api', // Always use proxy to avoid CORS issues
  clientId: isE2E
    ? 'pos-dashboard-test'
    : import.meta.env.VITE_API_CLIENT ?? 'pos-dashboard',
  redirectUri,
  newPasswordUrl,
  priceUnit: {
    symbol: import.meta.env.VITE_PRICE_UNIT_SYMBOL ?? '$',
    precision: import.meta.env.VITE_PRICE_UNIT_PRECISION ?? 2,
    text: import.meta.env.VITE_PRICE_UNIT_TEXT ?? 'USD',
  },
  clarity: {
    projectId: import.meta.env.VITE_POS_DASHBOARD_CLARITY_PROJECT_ID ?? '',
  },
};

export const bookAgeRatings = [
  { id: '0-3', name: '0-3' },
  { id: '3-6', name: '3-6' },
  { id: '6-12', name: '6-12' },
  { id: '12-18', name: '12-18' },
  { id: '18plus', name: '18+' },
];
export const bookLanguages = [
  { id: 'en', name: 'English' },
  { id: 'jp', name: 'Japanese' },
  { id: 'vn', name: 'Vietnamese' },
];
